import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {UnlockChoiceSentIllustration} from "./UnlockChoiceSentIllustration";

interface IProps {
    titleId: string;
    descriptionId: string;
    vendorName: string | null;
    subject: string;
}

export const UnlockChoiceSentContent = (props: IProps) => {
    const {titleId, descriptionId, vendorName, subject} = props;

    const vendorLabel = vendorName ? `Deweloper ${vendorName}` : "Deweloper";

    return (
        <div className={contentStyle}>
            <UnlockChoiceSentIllustration />

            <div role="status" className={textStyle}>
                <Text as="h2" id={titleId} variant="headline_4" align="center" color="var(--colors-secondary)">
                    Oferta już w drodze
                </Text>

                <Text as="p" id={descriptionId} variant="body_copy_2" align="center" color="var(--colors-gray-800)">
                    {vendorLabel} skontaktuje się z Tobą mailowo i telefonicznie w sprawie {subject}.
                </Text>
            </div>
        </div>
    );
};

const contentStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    rowGap: 3,
    px: 2,
    pt: 1.5,
    pb: 3,
    overflowX: "clip",
    md: {
        justifyContent: "center",
        minHeight: "58.6rem",
        pb: 1.5
    }
});

const textStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: "1rem",
    width: "100%"
});
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {UnlockChoiceSentIllustration} from "./UnlockChoiceSentIllustration";

interface IProps {
    titleId: string;
    descriptionId: string;
    vendorName: string | null;
    subject: string;
}

export const UnlockChoiceSentContent = (props: IProps) => {
    const {titleId, descriptionId, vendorName, subject} = props;

    const vendorLabel = vendorName ? `Deweloper ${vendorName}` : "Deweloper";

    return (
        <div className={contentStyle}>
            <UnlockChoiceSentIllustration />

            <div role="status" className={textStyle}>
                <Text as="h2" id={titleId} variant="headline_4" align="center" color="var(--colors-secondary)">
                    Oferta już w drodze
                </Text>

                <Text as="p" id={descriptionId} variant="body_copy_2" align="center" color="var(--colors-gray-800)">
                    {vendorLabel} skontaktuje się z Tobą mailowo i telefonicznie w sprawie {subject}.
                </Text>
            </div>
        </div>
    );
};

const contentStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    rowGap: 3,
    px: 2,
    pt: 1.5,
    pb: 3,
    overflowX: "clip",
    md: {
        justifyContent: "center",
        minHeight: "58.6rem",
        pb: 1.5
    }
});

const textStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: "1rem",
    width: "100%"
});
